<template>
  <div class="vision" id="achievements">
    <div class="container">
      <h1 class="section-title text-center">Our Achievement</h1>
      <p
        class="section-subtitle text-center"
      >Adpad not only offer media buying of external platforms but it also has got a pool of in house events that have the best viewership among the customers of various age group. Adpad is the exclusive broadcast media marketer of Nepal Idol, Nepal Lok Star and the biggest sporting event Everest Premier League.</p>

      <div class="row pt-5">
        <div class="col-md-8">
          <div class="img-container">
            <img src="/images/portfolioImages/nepalidol.jpg" class="img-fluid" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12 col-12">
              <img src="/images/portfolioImages/Lokstar.jpg" class="img-fluid" />
            </div>
            <div class="col-md-12 col-12">
              <img src="/images/portfolioImages/EPL.jpg" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>

<style scoped>
.vision {
  padding: 60px 0;
  border-top: 1px solid #e5e5e5;
}
.img-container {
  /* width: 200px; */
  height: 100%;
  overflow: hidden;
}
.img-container img {
  height: 100%;
}
</style>